export default __webpack_public_path__ + "assets/Menu.9dcc300d.svg";